import { Outlet } from 'react-router-dom';
import { AppShell, Center, Loader } from '@mantine/core';
import { useState } from 'react';
import { useAuth0 } from '../../hooks/useAuth0';
import { useNavigationState } from '@/hooks/useNavigationState';
import { useCurrentSession } from '@/hooks/useCurrentSession';
import { SECTIONS } from '@/utils/routes';
import { AppHeader } from './AppHeader';
import { AppNavbar } from './AppNavbar';

export const AppLayout = () => {
  const [opened, setOpened] = useState(false);
  const { isLoading: authLoading, organization, isAuthenticated } = useAuth0();
  const { isLoading: sessionLoading } = useCurrentSession();
  const navigationState = useNavigationState();

  const { progress, isLoading: progressLoading, plgSectionVisible } = navigationState;

  if (authLoading || sessionLoading || progressLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }


  const sectionsWithProgress = SECTIONS.map(section => {
    if (!isAuthenticated) {
      return null;
    }

    const pagesWithNavState = section.pages.map(page => {
      let pageStatus = 'not_started';
      let enabled = true;
      
      if (progress) {
        if (page.id === 'welcome') {
          pageStatus = progress.welcome === 'completed' ? 'completed' : 'not_started';
          enabled = navigationState.welcomeEnabled;
        } else if (page.id === 'search') {
          pageStatus = progress.search === 'completed' ? 'completed' : 
                     progress.search === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.searchEnabled;
        } else if (page.id === 'confirm') {
          pageStatus = progress.confirm === 'completed' ? 'completed' : 
                     progress.confirm === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.confirmEnabled;
        } else if (page.id === 'submit') {
          pageStatus = progress.submit === 'completed' ? 'completed' : 
                     progress.submit === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.submitEnabled;
        } else if (page.id === 'char-income') {
          pageStatus = progress.char_income === 'completed' ? 'completed' : 
                     progress.char_income === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.charIncomeEnabled;
        } else if (page.id === 'char-nextsteps') {
          pageStatus = navigationState.charIncomeEnabled ? 'completed' : 'not_started';
          enabled = navigationState.charIncomeEnabled;
        } else if (page.id === 'char-section8') {
          pageStatus = progress.char_section8 === 'completed' ? 'completed' : 
                     progress.char_section8 === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.charSection8Enabled;
        } else if (page.id === 'char-newconstruction') {
          pageStatus = progress.char_newconstruction === 'completed' ? 'completed' : 
                     progress.char_newconstruction === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.charNewConstructionEnabled;
        } else if (page.id === 'char-student') {
          pageStatus = progress.char_student === 'completed' ? 'completed' : 
                     progress.char_student === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.charStudentEnabled;
        } else if (page.id === 'char-sharedops') {
          pageStatus = progress.char_sharedops === 'completed' ? 'completed' : 
                     progress.char_sharedops === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.charSharedOpsEnabled;
        } else if (page.id === 'char-submit') {
          pageStatus = progress.char_submit === 'completed' ? 'completed' :
                     progress.char_submit === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.charSubmitForReviewEnabled;
        } else if (page.id === 'impl-nextsteps') {
          pageStatus = navigationState.implContactsEnabled ? 'completed' : 'not_started';
          enabled = navigationState.implContactsEnabled;
        } else if (page.id === 'impl-project-lead') {
          pageStatus = progress.impl_project_lead === 'completed' ? 'completed' :
                     progress.impl_project_lead === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.implProjectLeadEnabled;
        } else if (page.id === 'impl-technical') {
          pageStatus = progress.impl_technical === 'completed' ? 'completed' :
                     progress.impl_technical === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.implTechnicalEnabled;
        } else if (page.id === 'impl-voice') {
          pageStatus = progress.impl_voice === 'completed' ? 'completed' :
                     progress.impl_voice === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.implVoiceEnabled;
        } else if (page.id === 'impl-marketing') {
          pageStatus = progress.impl_marketing === 'completed' ? 'completed' :
                     progress.impl_marketing === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.implMarketingEnabled;
        } else if (page.id === 'impl-knowledge') {
          pageStatus = progress.impl_knowledge === 'completed' ? 'completed' :
                     progress.impl_knowledge === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.implKnowledgeEnabled;
        } else if (page.id === 'impl-training') {
          pageStatus = progress.impl_training === 'completed' ? 'completed' :
                     progress.impl_training === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.implTrainingEnabled;
        } else if (page.id === 'impl-owner') {
          pageStatus = progress.impl_owner === 'completed' ? 'completed' :
                     progress.impl_owner === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.implOwnerEnabled;
        } else if (page.id === 'impl-submit') {
          pageStatus = progress.impl_submit === 'completed' ? 'completed' :
                     progress.impl_submit === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.implSubmitEnabled;
        } else if (page.id === 'plg-elisego-name') {
          pageStatus = progress.plg_name === 'completed' ? 'completed' : 
                     progress.plg_name === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.plgNameEnabled;
        } else if (page.id === 'plg-ai-name') {
          pageStatus = progress.plg_ai_name === 'completed' ? 'completed' : 
                     progress.plg_ai_name === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.plgAINameEnabled;
        } else if (page.id === 'plg-voice-area-code') {
          pageStatus = progress.plg_voice_area === 'completed' ? 'completed' : 
                     progress.plg_voice_area === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.plgVoiceAreaEnabled;
        } else if (page.id === 'plg-schedule-tours') {
          pageStatus = progress.plg_schedule === 'completed' ? 'completed' : 
                     progress.plg_schedule === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.plgScheduleEnabled;
        } else if (page.id === 'plg-submit') {
          pageStatus = progress.plg_submit === 'completed' ? 'completed' :
                     progress.plg_submit === 'in_progress' ? 'in_progress' : 'not_started';
          enabled = navigationState.plgSubmitEnabled;
        }
      }
      const displayStatus = enabled ? pageStatus : 'not_started';
      return {
        ...page,
        status: displayStatus,
        enabled,
      };
    });

    // Calculate section status based on page progress
    const anyInProgress = pagesWithNavState.some(p => p.status === 'in_progress');
    const anyCompleted = pagesWithNavState.some(p => p.status === 'completed');
    const allCompleted = pagesWithNavState.every(p => p.status === 'completed');
    let sectionStatus = allCompleted
      ? 'completed'
      : anyInProgress || anyCompleted
        ? 'in_progress'
        : 'not_started';

    // Special handling for implementation-contacts section
    // Since contacts can be skipped, mark section as completed when submit is completed
    if (section.id === 'implementation-contacts') {
      const submitPage = pagesWithNavState.find(p => p.id === 'impl-submit');
      if (submitPage && submitPage.status === 'completed') {
        sectionStatus = 'completed';
      }
    }

    // Determine if the section (as a whole) should appear enabled
    let sectionEnabled = true;
    if (section.id === 'community-characteristics') {
      sectionEnabled = navigationState.charIncomeEnabled;
    } else if (section.id === 'implementation-contacts') {
      sectionEnabled = navigationState.implContactsEnabled;
    } else if (section.id === 'elisego-configuration') {
      sectionEnabled = navigationState.plgEnabled;
    }
    if (sectionEnabled === false) {
      sectionStatus = 'not_started';
    }

    return {
      ...section,
      status: sectionStatus,
      pages: pagesWithNavState,
      enabled: sectionEnabled,
    } as any;
  }).filter(section => {
    // Filter out null/undefined sections
    if (!section) return false;
    // Hide EliseGO section when PLG is not visible (product_led_growth flag is false)
    if (section.id === 'elisego-configuration' && !plgSectionVisible) {
      return false;
    }
    return true;
  });

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 300,
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
      }}
      padding="md"
    >
      <AppHeader 
        opened={opened}
        setOpened={setOpened}
        organization={organization}
      />

      <AppNavbar sectionsWithProgress={sectionsWithProgress} />

      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
};